import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import {
  LoginRiskDeploymentHealthDto,
  LoginRiskDeploymentStatusDto,
  MlDeploymentHealthAlertDto
} from '../../../_core/_model/machine-learning';
import { MachineLearningAdminService } from '../../../_core/_services/machine-learning-admin.service';

@Component({
  selector: 'app-admin-ml-deployment-health',
  standalone: false,
  templateUrl: './admin-ml-deployment-health.html',
  styleUrl: './admin-ml-deployment-health.css'
})
export class AdminMlDeploymentHealth implements OnInit {
  loading = false;
  error = '';
  windowHours = 24;
  status: LoginRiskDeploymentStatusDto | null = null;
  health: LoginRiskDeploymentHealthDto | null = null;
  alerts: MlDeploymentHealthAlertDto[] = [];

  constructor(private mlService: MachineLearningAdminService) {}

  ngOnInit(): void { this.load(); }

  load(): void {
    this.loading = true;
    this.error = '';
    this.windowHours = Math.min(168, Math.max(1, Number(this.windowHours) || 24));
    forkJoin({
      status: this.mlService.getLoginRiskDeploymentStatus(),
      health: this.mlService.getLoginRiskDeploymentHealth(this.windowHours),
      alerts: this.mlService.getLoginRiskDeploymentAlerts(this.windowHours)
    }).subscribe({
      next: result => {
        this.status = result.status.data;
        this.health = result.health.data;
        this.alerts = result.alerts.data || [];
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.error = error.error?.error?.details || error.error?.message || error.message || 'Unable to load deployment health.';
        this.loading = false;
      }
    });
  }

  badgeClass(value?: string | null): string {
    switch ((value || '').toLowerCase()) {
      case 'healthy': case 'active': case 'ready': return 'text-bg-success';
      case 'watch': case 'canary': case 'insufficientdata': return 'text-bg-warning text-dark';
      case 'critical': case 'failed': return 'text-bg-danger';
      case 'disabled': case 'nodeployment': return 'text-bg-secondary';
      default: return 'text-bg-light text-dark border';
    }
  }

  alertClass(value?: string | null): string {
    switch ((value || '').toLowerCase()) {
      case 'critical': return 'alert-danger';
      case 'high': return 'alert-warning';
      default: return 'alert-info';
    }
  }
}
